// Translations
import landing from '../views/landing/translations/ru'

// Translation: Terms of service (Russian)
export default Object.freeze({
	name: '',
	views: { landing }
})
